// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clearance-form .clearance-form-type-selector{display:flex;gap:0.75rem;margin-bottom:1.5rem;flex-wrap:wrap}.clearance-form .clearance-form-type-selector .btn{flex:1 1 auto}.clearance-form .clearance-form-type-selector .btn:disabled{opacity:0.65}.clearance-form .clearance-form-type-selector .btn svg{margin-right:0.35rem;vertical-align:text-bottom}@media (max-width: 767.98px){.clearance-form .formations-form-field-col{width:100% !important}}\n", ""]);
// Exports
module.exports = exports;
